import axios from 'axios';

// search vat input api
export async function searchBankAPI(Data) {
	let banklist = [];
	const bankVal = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/banks/search/?bankName=${bankVal}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		banklist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return banklist;
}

// check existing vat input api
export async function getBankAPI(Data) {
	let banklist = [];
	const bankName = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/banks/getBank/?bankName=${bankName}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		banklist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return banklist;
}

//create status api
export async function createBankAPI(Data, userID) {
	let bankData = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/banks/create/`,
			data: {Data, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		bankData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return bankData;
}

//update status api
export async function updateBankAPI(Data, bankID, userID) {
	let bankData = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/banks/update/?bankID=${bankID}&userID=${userID}`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		bankData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return bankData;
}